import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface grading {
    message: any;
    isLoading: boolean;
    error: string | null;
}

const initialState: grading = {
    message: null,
    isLoading: false,
    error: null,
};

const courseSlice = createSlice({
    name: "editGrading",
    initialState,
    reducers: {
        setGrading: (state: grading, action: PayloadAction<grading>) => {
            state.message = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: grading, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: grading, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetGrading: () => {
            return initialState;
        },
    },
});

export const {
    setloading,
    seterror,
    setGrading,
    resetGrading,
} = courseSlice.actions;

export default courseSlice.reducer;
